import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePageOne from "./pages/Auth/HomePageOne";

import SubadminPage from "./pages/SubAdmin/SubAdminListPage";
import AddSubadminPage from "./pages/SubAdmin/AddSubAdminPage";
import EditSubadminPage from "./pages/SubAdmin/EditSubadminPage";

import ViewSubadminPage from "./pages/SubAdmin/ViewSubadminPage";
import ErrorPage from "./pages/ErrorPage";
import SignInPage from "./pages/Auth/SignInPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import ComingSoonPage from "./pages/ComingSoonPage";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import MaintenancePage from "./pages/MaintenancePage";
import BlankPagePage from "./pages/BlankPagePage";
import SettingPage from "./pages/Setting/SettingPage";

import FAQPage from "./pages/FAQ/FAQList";
import AddFAQPage from "./pages/FAQ/AddFAQPage";
import EditFAQPage from "./pages/FAQ/EditFAQPage";
import ViewFAQPage from "./pages/FAQ/ViewFAQPage";

import CMSPage from "./pages/CMS/CMSList";
import AddCMSPage from "./pages/CMS/AddCMSPage";
import EditCMSPage from "./pages/CMS/EditCMSPage";
import ViewCMSPage from "./pages/CMS/ViewCMSPage";

import AdminLogsPage from "./pages/Logs/AdminLogList";
import ViewProfilePage from "./pages/Auth/ViewProfilePage";

import HostBusinessPage from "./pages/HostBusiness/HostBusinessListPage";
import ViewHostBusinessPage from "./pages/HostBusiness/ViewHostBusinessPage";

import HostIndividualPage from "./pages/HostIndividual/HostIndividualListPage";
import ViewHostIndividualPage from "./pages/HostIndividual/ViewHostIndividualPage";

import SpacePage from "./pages/StorageSpace/SpaceListPage";
import ViewStorageSpace from "./pages/StorageSpace/ViewSpacePage";
import EditStorageSpace from "./pages/StorageSpace/EditStorageSpace";

import SpaceType from "./pages/StorageSpaceType/SpaceTypeListPage";
import AddSpaceType from "./pages/StorageSpaceType/AddStorageSpaceTypePage";
import EditSpaceType from "./pages/StorageSpaceType/EditStorageSpaceTypePage";
import ViewSpaceType from "./pages/StorageSpaceType/ViewSpacePageTypeLayer";

import Insulated from "./pages/Insulated/InsulatedList";
import AddInsulated from "./pages/Insulated/AddInsulatedPage";
import EditInsulated from "./pages/Insulated/EditInsulatedPage";
import ViewInsulated from "./pages/Insulated/ViewInsulated";

import RenterPage from "./pages/Renter/RenterListPage";
import ViewRenterPage from "./pages/Renter/ViewRenterPage";

import Promiotion from "./pages/promotion/PromiotionList";
import AddPromotion from "./pages/promotion/AddPromotionPage";
import EditPromotion from "./pages/promotion/EditPromotionPage";
import ViewPromotion from "./pages/promotion/ViewPromotion";

import Amenities from "./pages/amenities/AmenitiesListPage";
import AddAmenities from "./pages/amenities/AddAmenitiesPage";
import EditAmenities from "./pages/amenities/EditAmenitiesPage";
import ViewAmenities from "./pages/amenities/ViewAmenities";


import AccessType from "./pages/accessType/AcessTypeListPage";
import AddAccessType from "./pages/accessType/AddAccessTypePage";
import EditAccessType from "./pages/accessType/EditAccessTypePage";
import ViewAccessType from "./pages/accessType/ViewAcessType";

import SupportTicket from "./pages/SupportTicket/SupportTicketList";
import ViewSupportTicket from "./pages/SupportTicket/ViewSupportTicket";

import BookingPage from "./pages/Booking/BookingList";
import ViewBokingPage from "./pages/Booking/ViewBookingPage";

import ChatPaymentPage from "./pages/chatTransactionPayment/ChatPaymentList";
import ViewChatPaymentPage from "./pages/chatTransactionPayment/ViewChatPaymentPage";

import PromiotionPayment from "./pages/promotionPayment/PromiotionPaymentList";
import ViewPromotionPaymentPage from "./pages/promotionPayment/ViewPromotionPaymentPage";

import SendNotification from "./pages/notification/AddNotification";
import Notification from "./pages/notification/NotificationList";

import Analytic from "./pages/analytic/AnalyticList";

function App() {
  return (
            <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
            {/* <BrowserRouter>    */}
            <RouteScrollToTop />
            <Routes>
            {/* Auth */}
            <Route exact path='/' element={<SignInPage />} />
            <Route exact path='/sign-in' element={<SignInPage />} />
            <Route exact path='/dashboard' element={<HomePageOne />} />
            <Route exact path='/view-profile' element={<ViewProfilePage />} />
            {/******** Sub Admin ***** */}
            <Route exact path='/subadmin' element={<SubadminPage />} />
            <Route exact path='/subadmin/add-Subadmin' element={<AddSubadminPage />} />
            <Route exact path='/subadmin/edit-Subadmin/:id?' element={<EditSubadminPage />} />
            <Route exact path='/subadmin/view-Subadmin/:id?' element={<ViewSubadminPage />} />
            {/******** Host Business ***** */}
            <Route exact path='/host-business' element={<HostBusinessPage />} />
            <Route exact path='/host-business/view-hostbusiness/:id?' element={<ViewHostBusinessPage />} />
            {/******** Host Individual ***** */}
            <Route exact path='/host-individual' element={<HostIndividualPage />} />
            <Route exact path='/host-individual/view-hostindividual/:id?' element={<ViewHostIndividualPage />} />
            {/********storage-space ***** */}
            <Route exact path='/storage-space' element={<SpacePage />} />
            <Route exact path='/storage-space/view-storagespace/:id?' element={<ViewStorageSpace />} />
            <Route exact path='/storage-space/edit-storagespace/:id?' element={<EditStorageSpace />} />
            {/********storage-space-type ***** */}
            <Route exact path='/space-type' element={<SpaceType />} />
            <Route exact path='/space-type/add' element={<AddSpaceType />} />
            <Route exact path='/space-type/edit/:id?' element={<EditSpaceType />} />
            <Route exact path='/space-type/view/:id?' element={<ViewSpaceType />} />
              {/******** Isulated ***** */}
            <Route exact path='/insulated' element={<Insulated />} />
            <Route exact path='/insulated/add' element={<AddInsulated />} />
            <Route exact path='/insulated/edit/:id?' element={<EditInsulated />} />
            <Route exact path='/insulated/view/:id?' element={<ViewInsulated />} />
            {/******** Renter ***** */}
            <Route exact path='/renter' element={<RenterPage />} />
            <Route exact path='/renter/view-renter/:id?' element={<ViewRenterPage />} />
            {/******** Setting ***** */}
            <Route exact path='/setting' element={<SettingPage />} />
            {/******** FAQ ***** */}
            <Route exact path='/faq' element={<FAQPage />} />
            <Route exact path='/faq/add-faq' element={<AddFAQPage />} />
            <Route exact path='/faq/edit-faq/:id?' element={<EditFAQPage />} />
            <Route exact path='/faq/view-faq/:id?' element={<ViewFAQPage />} />
            {/******** CMS ***** */}
            <Route exact path='/cms' element={<CMSPage />} />
            <Route exact path='/cms/add-cms' element={<AddCMSPage />} />
            <Route exact path='/cms/edit-cms/:id?' element={<EditCMSPage />} />
            <Route exact path='/cms/view-cms/:id?' element={<ViewCMSPage />} />
            {/******** Logs ***** */}
            <Route exact path='/adminlog' element={<AdminLogsPage />} />
            {/******** Promotion ***** */}
            <Route exact path='/promotion' element={<Promiotion />} />
            <Route exact path='/promotion/add' element={<AddPromotion />} />
            <Route exact path='/promotion/edit/:id?' element={<EditPromotion />} />
            <Route exact path='/promotion/view/:id?' element={<ViewPromotion />} />
            {/******** PromotionPaymnet ***** */}
            <Route exact path='/transaction-promotion' element={<PromiotionPayment />} />
            <Route exact path='/transaction-promotion/view/:id?' element={<ViewPromotionPaymentPage />} />
            {/******** Booking ***** */}
            <Route exact path='/booking' element={<BookingPage />} />
            <Route exact path='/booking/view/:id?' element={<ViewBokingPage />} />
            {/******** chatPayment ***** */}
            <Route exact path='/chatpayment' element={<ChatPaymentPage />} />
            <Route exact path='/chatpayment/view/:id?' element={<ViewChatPaymentPage />} />
            {/******** Amenities ***** */}
            <Route exact path='/amenities' element={<Amenities />} />
            <Route exact path='/amenities/add' element={<AddAmenities />} />
            <Route exact path='/amenities/edit/:id?' element={<EditAmenities />} />
            <Route exact path='/amenities/view/:id?' element={<ViewAmenities />} />
            {/******** AccessType ***** */}
            <Route exact path='/accesstype' element={<AccessType />} />
            <Route exact path='/accesstype/add' element={<AddAccessType />} />
            <Route exact path='/accesstype/edit/:id?' element={<EditAccessType />} />
            <Route exact path='/accesstype/view/:id?' element={<ViewAccessType />} />
            {/******** Notification ***** */}
            <Route exact path='/notification' element={<Notification />} />
            <Route exact path='/notification/sent' element={<SendNotification />} /> 
            {/******** Support Ticket ***** */}
            <Route exact path='/supportticket' element={<SupportTicket />} />
            <Route exact path='/supportticket/view/:id?' element={<ViewSupportTicket />} />
            {/* <Route exact path='/supportticket/add' element={<AddAccessType />} />
            <Route exact path='/supportticket/edit/:id?' element={<EditAccessType />} />
            <Route exact path='/supportticket/view/:id?' element={<ViewAccessType />} /> */}
            {/******** Analytic ***** */}
             <Route exact path='/analytic' element={<Analytic />} />
            {/* *********** Extra PAges ************ */}
            <Route exact path='/coming-soon' element={<ComingSoonPage />} />
            <Route exact path='/access-denied' element={<AccessDeniedPage />} />
            <Route exact path='/maintenance' element={<MaintenancePage />} />
            <Route exact path='/blank-page' element={<BlankPagePage />} />
            {/* <Route exact path='*' element={<ErrorPage />} /> */}
            <Route exact path='*' element={<ComingSoonPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
